// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  height: 58px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  border-top: 1px #cccccc solid;
  position: relative;
  background-color: #ffffff !important;
}
.footer .row {
  width: 100% !important;
}
.footer .row span {
  font-weight: bold;
  margin-top: 15px !important;
  margin-left: 10px !important;
}
.footer .row a {
  margin-top: 9px;
  margin-left: 5px;
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/layout/footer/footer.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,oCAAA;AADF;AAGE;EACE,sBAAA;AADJ;AAGI;EACE,iBAAA;EACA,2BAAA;EACA,4BAAA;AADN;AAII;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAFN","sourcesContent":["@import 'edozvola-frontend-lib/dist/assets/css/00-settings/colors';\n\n.footer {\n  height: 58px;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  border-top: 1px #cccccc solid;\n  position: relative;\n  background-color: #ffffff !important;\n\n  .row {\n    width: 100% !important;\n\n    span {\n      font-weight: bold;\n      margin-top: 15px !important;\n      margin-left: 10px !important;\n    }\n\n    a {\n      margin-top: 9px;\n      margin-left: 5px;\n      margin-right: 5px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
